export default __webpack_public_path__ + "static/hand-ee1430e95f72ddfaef6fe801a466b2cc.png";